import type {
  ApiAcademyCourse,
  ApiAcademyLesson,
  ApiAcademyLessonPicture,
  ApiAcademyLessonRecord,
  ApiAvatar,
  ApiSitter,
} from '@app/packages/api/v2/types/entities'

export type AcademyCourse = { course: ApiAcademyCourse; brand: ApiAcademyCourse['attributes']['brand'] }
export type AcademyLesson = {
  id: ApiAcademyLesson['id']
  pictures: ApiAcademyLessonPicture[]
  course: AcademyCourse
  sitter: ({ id: string; avatars: ({ id: string } & ApiAvatar['attributes'])[] } & ApiSitter['attributes']) | null
} & ApiAcademyLesson['attributes']

export type AcademyLessonRecord = {
  id: string
  lesson: AcademyLesson & { zoom_link: string | null; zoom_password: string | null }
} & ApiAcademyLessonRecord['attributes']

export const toCourseBundle = (course: ApiAcademyCourse): AcademyCourse => {
  return {
    course,
    brand: course.attributes.brand ? course.attributes.brand : course.id === '27' ? { name: 'meeting_with_santa' } : course.attributes.brand,
  }
}
